import enableAlgolia from './enable-algolia';

export function searchPageResult() {
	if ( ! enableAlgolia || MWC_AIS.search_page !== 'yes' ) {
		return false;
	}
	const container = MWC_AIS.dom_selectors.input_selector;

	const input = document
		.querySelector( container )
		.querySelector( 'input[type="search"]' );

	input.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Enter' ) {
			window.location =
				MWC_AIS.site_url + '/?s=' + input.value + '&post_type=product';
		}
	} );
}
